var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 206,
    viewBox: "0 0 206 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_10234)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.049,
    cy: 41.5412,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.977,
    cy: 59.2023,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.456,
    cy: 68.2716,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.069,
    cy: 98.3434,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.307,
    cy: 100.372,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.565 100.372C167.565 137.18 137.461 167.034 100.307 167.034C63.1531 167.034 33.0488 137.18 33.0488 100.372C33.0488 63.5644 63.1531 33.7107 100.307 33.7107C137.461 33.7107 167.565 63.5644 167.565 100.372Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.6144,
    cy: 69.7038,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.1662,
    cy: 181.877,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.6701,
    cy: 192.855,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.95,
    cy: 179.967,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.696,
    cy: 177.103,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 128.47,
    cy: 190.946,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.854,
    cy: 196.674,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 174.294,
    cy: 166.841,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.568,
    cy: 138.439,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 180.261,
    cy: 123.642,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 184.079,
    cy: 93.57,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.955,
    cy: 77.341,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 186.466,
    cy: 40.8252,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.8154,
    cy: 199.06,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.6865,
    cy: 194.287,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 44.4599,
    cy: 185.934,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 13.4336,
    cy: 147.748,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20.3545,
    cy: 132.95,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.69333,
    cy: 94.5249,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.5478,
    cy: 64.6919,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.3662,
    cy: 22.448,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.8828,
    cy: 6.21872,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 108.422,
    cy: 24.8347,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.436,
    cy: 18.8679,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.475 150.373C169.42 150.373 168.565 149.518 168.565 148.464C168.565 147.409 169.42 146.554 170.475 146.554",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51172 117.675C7.56621 117.675 8.42104 116.821 8.42104 115.766C8.42104 114.712 7.56621 113.857 6.51172 113.857",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 22.448C75.5857 22.448 76.4406 21.5932 76.4406 20.5387C76.4406 19.4842 75.5857 18.6294 74.5312 18.6294",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.833 15.7653C119.779 15.7653 118.924 16.6202 118.924 17.6747C118.924 18.7292 119.779 19.584 120.833 19.584",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3301 166.96H16.2967M26.3207 155.862V157.413M38.0153 166.96H39.5666M26.3207 176.506V178.296M26.3207 180.683V187.008M21.9053 166.96C24.8887 166.96 26.44 162.664 26.44 162.664C26.44 162.664 26.9173 166.96 30.736 166.96C29.0176 166.96 26.5593 168.511 26.3207 171.614C26.3207 171.614 26.0428 169.074 25.1273 168.153C24.363 167.385 21.9053 166.96 21.9053 166.96Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.709 30.085L172.742 30.085M162.599 45.8369L162.718 39.6316M151.024 30.085L149.472 30.085M162.599 20.777L162.599 8.60512M167.134 30.085C164.15 30.085 162.599 34.3809 162.599 34.3809C162.599 34.3809 162.122 30.085 158.303 30.085C160.021 30.085 162.48 28.5336 162.718 25.431C162.718 25.431 162.996 27.9712 163.912 28.8916C164.676 29.6602 167.134 30.085 167.134 30.085Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3372 78.0405H37.8898L38.1838 78.5084L42.1469 84.8141C42.5389 85.4379 43.4481 85.4379 43.8402 84.8141L47.8032 78.5084L48.0973 78.0405H48.6499H122.359C123.464 78.0405 124.359 77.1451 124.359 76.0405V55.2222C124.359 54.1176 123.464 53.2222 122.359 53.2222H23.8711C22.7665 53.2222 21.8711 54.1176 21.8711 55.2222V76.0405C21.8711 77.1451 22.7665 78.0405 23.8711 78.0405H37.3372Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.7412,
    y1: 62.2715,
    x2: 116.459,
    y2: 62.2715,
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.7412,
    y1: 68.2715,
    x2: 68.1387,
    y2: 68.2715,
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3372 142.022H42.8898L43.1838 142.49L47.1469 148.795C47.5389 149.419 48.4481 149.419 48.8402 148.795L52.8032 142.49L53.0973 142.022H53.6499H127.359C128.464 142.022 129.359 141.126 129.359 140.022V119.203C129.359 118.099 128.464 117.203 127.359 117.203H28.8711C27.7665 117.203 26.8711 118.099 26.8711 119.203V140.022C26.8711 141.126 27.7665 142.022 28.8711 142.022H42.3372Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.7412,
    y1: 126.253,
    x2: 121.459,
    y2: 126.253,
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.7412,
    y1: 132.253,
    x2: 73.1387,
    y2: 132.253,
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.893 110.041H184.376L184.077 110.463L180.053 116.154C179.655 116.717 178.819 116.717 178.42 116.154L174.397 110.463L174.098 110.041H173.581H99.8711C98.7665 110.041 97.8711 109.145 97.8711 108.041V87.2222C97.8711 86.1176 98.7665 85.2222 99.8711 85.2222H198.359C199.464 85.2222 200.359 86.1176 200.359 87.2222V108.041C200.359 109.145 199.464 110.041 198.359 110.041H184.893Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 87.8359,
    y2: -1,
    transform: "matrix(-1 0 0 1 193.607 95.5708)",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 37.1387,
    y2: -1,
    transform: "matrix(-1 0 0 1 142.91 101.571)",
    stroke: "#194590",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_10234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.5 0.0253906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChats);
export default __webpack_public_path__ + "static/media/no-chats.630397fb3b5268ee5dfc9439da458b13.svg";
export { ForwardRef as ReactComponent };